import {
  CREATE_TERMINAL_REQUEST_ASYNC,
  CREATE_TERMINAL_REQUEST_ASYNC_END,
  CREATE_TERMINAL_REQUEST_END_COMPLETE,
  FETCH_TERMINAL_PRICE_ASYNC,
  FETCH_TERMINAL_PRICE_ASYNC_END,
  FETCH_TERMINAL_PRICE_END_COMPLETE,
  FETCH_ALL_TERMINAL_START_ASYNC,
  FETCH_ALL_TERMINAL_END_ASYNC,
  FETCH_ALL_TERMINALS,
  FETCH_TERMINAL_REQUESTS,
  ACTIVATE_TERMINAL_ASYNC_START,
  ACTIVATE_TERMINAL_ASYNC_END,
  ACTIVATE_TERMINAL_REQUEST,
} from 'store/types';
import Terminal from 'services/terminal';
import { toast } from 'react-toastify';
import { showToast } from './toast';

export const fetchTerminalPrice = () => async (dispatch) => {
  dispatch({
    type: FETCH_TERMINAL_PRICE_ASYNC,
  });

  try {
    const data = await Terminal.getTerminalPrice();
    dispatch({
      type: FETCH_TERMINAL_PRICE_END_COMPLETE,
      payload: data[0],
    });
  } catch (error) {
    dispatch({
      type: FETCH_TERMINAL_PRICE_ASYNC_END,
    });
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const requestTerminal = (body, onSuccess) => async (dispatch) => {
  dispatch({
    type: CREATE_TERMINAL_REQUEST_ASYNC,
  });

  try {
    await Terminal.requestTerminal(body);
    dispatch({
      type: CREATE_TERMINAL_REQUEST_END_COMPLETE,
    });
    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    dispatch({
      type: CREATE_TERMINAL_REQUEST_ASYNC_END,
    });
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const fetchTerminals = (params) => async (dispatch) => {
  dispatch({
    type: FETCH_ALL_TERMINAL_START_ASYNC,
    subType: 'terminals',
  });

  await Terminal.fetchTerminals(params)
    .then((res) => {
      if (res.status === 200) {
        const {
          data: { list, ...rest },
        } = res;
        dispatch({
          type: FETCH_ALL_TERMINALS,
          payload: { list, pagination: rest },
          subType: 'terminals',
        });
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    })
    .catch((e) => {
      dispatch({
        type: FETCH_ALL_TERMINAL_END_ASYNC,
        subType: 'terminals',
      });
      toast.error(e?.message || 'Something went wrong');
    });
};

export const fetchTerminalRequests = (params) => async (dispatch) => {
  dispatch({
    type: FETCH_ALL_TERMINAL_START_ASYNC,
    subType: 'terminalRequests',
  });

  await Terminal.getTerminalRequests(params)
    .then((res) => {
      const {
        data: { list, ...rest },
      } = res;
      if (res.status === 200) {
        dispatch({
          type: FETCH_TERMINAL_REQUESTS,
          payload: { list, pagination: rest },
          subType: 'terminalRequests',
        });
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    })
    .catch((e) => {
      dispatch({
        type: FETCH_ALL_TERMINAL_END_ASYNC,
        subType: 'terminalRequests',
      });
      toast.error(e?.message || 'Something went wrong');
    });
};

export const activateTerminal =
  (params, onSuccess = () => {}, onFailure = () => {}) =>
  async (dispatch, getState) => {
    dispatch({
      type: ACTIVATE_TERMINAL_ASYNC_START,
      subType: 'terminals',
    });

    const {
      common: { user },
    } = getState();

    const terminalParams = {
      ...params,
      merchantId: user?.merchantId,
    };

    await Terminal.activateTerminal(terminalParams)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          dispatch({
            type: ACTIVATE_TERMINAL_REQUEST,
            subType: 'terminals',
            payload: response.data,
          });
          onSuccess();
        } else {
          dispatch({
            type: ACTIVATE_TERMINAL_REQUEST,
            subType: 'terminals',
            error: response.message,
          });
          onFailure(response?.message || 'Something went wrong');
        }
      })
      .catch((e) => {
        dispatch({
          type: ACTIVATE_TERMINAL_ASYNC_END,
          subType: 'terminals',
        });
        onFailure('Something went wrong. Try again');
      });
  };
